module.exports = __webpack_public_path__ + "img/your-rewards-ftue.cc6a51fc.svg";